import { useLoaderData } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { apiGetBestWrestlerListStats } from '../../../components/ui_components/ApiList';
import GeneralRenderingSpecificStats from '../../../components/MobileComponents/Stats/GeneralRenderingSpecificStats';


const BestWrestlerMobile = () => {
    const wrestlersData = (useLoaderData() as any)?.['data'] ?? [];
    const [searchParams] = useSearchParams();
    const year = searchParams.get('year') || 'globale';

    return (
        <GeneralRenderingSpecificStats
            apiFunctionGetStats={apiGetBestWrestlerListStats}
            title="Rankings"
            stat="importance_score"
            yearStart={year}
            wrestlerDataStart={wrestlersData}
        />
    );
};

export default BestWrestlerMobile;